// eslint-disable-next-line
export const SUCCESS_MESSAGES = {
  organizationAddSaveSuccessTitle() {
    return `Vytvořeno`
  },
  organizationAddSaveSuccessMessage(name) {
    return `Organizace ${name} byla vytvořena`
  },
  organizationEditSaveSuccessTitle() {
    return `Upraveno`
  },
  organizationEditSaveSuccessMessage(name) {
    return `Organizace ${name} byla upravena`
  },
  userAddSaveSuccessTitle() {
    return `Vytvořeno`
  },
  userAddSaveSuccessMessage(name) {
    return `Uživatel ${name} byl vytvořen`
  },
  userEditSaveSuccessTitle() {
    return `Upraveno`
  },
  userEditSaveSuccessMessage(name) {
    return `Uživatel ${name} byl upraven`
  },
  groupAddSaveSuccessTitle() {
    return `Vytvořeno`
  },
  groupAddSaveSuccessMessage(name) {
    return `Skupina ${name} byla vytvořena`
  },
  groupEditSaveSuccessTitle() {
    return `Upraveno`
  },
  groupEditSaveSuccessMessage(name) {
    return `Skupina ${name} byla upravena`
  },
  meetingAddSaveSuccessTitle() {
    return `Vytvořeno`
  },
  meetingAddSaveSuccessMessage() {
    return `Zasedání bylo vytvořeno`
  },
  meetingEditSaveSuccessTitle() {
    return `Upraveno`
  },
  meetingEditSaveSuccessMessage() {
    return `Zasedání bylo upraveno`
  },
  voteAddSaveSuccessTitle() {
    return `Vytvořeno`
  },
  voteAddSaveSuccessMessage() {
    return `Hlasování bylo vytvořeno`
  },
  emailSentSuccessTitle() {
    return `Odesláno`
  },
  emailSentSuccessMessage() {
    return `Email byl odeslán`
  },
}
